import CreditsTabContent from '@modules/app-steps/step-two/tabs/credits/index.vue'
import OrderTypeTabContent from '@modules/app-steps/step-two/tabs/order-type/index.vue'
import PackagesTabContent from '@modules/app-steps/step-two/tabs/packages/index.vue'
import UploadTabContent from '@modules/app-steps/step-two/tabs/upload/index.vue'
import ImagesTabContent from '@modules/app-steps/step-two/tabs/images/index.vue'
import TargetingTabContent from '@modules/app-steps/step-two/tabs/targeting/index.vue'
import ScheduleTabContent from '@modules/app-steps/step-two/tabs/schedule/index.vue'
import PrepayTabContent from '@modules/app-steps/step-two/tabs/prepay/index.vue'
import WritingTabContent from '@modules/app-steps/step-two/tabs/writing/index.vue'

import { markRaw } from 'vue'
import { v4 as uuid } from 'uuid'

export const TabNames = {
  Credits: 'Credits',
  OrderType: 'Order Type',
  Packages: 'Packages',
  Writing: 'Writing',
  Upload: 'Upload',
  Images: 'Images',
  Targeting: 'Targeting',
  Schedule: 'Schedule',
  Prepay: 'Prepay',
}

export const OrderTypes = {
  UnSelected: 'unselected',
  Normal: 'normal',
  CreditOnly: 'credit-only',
  WritingService: 'writing-service',
  RedeemedCredit: 'redeemed-credit',
  RedeemedCreditWriting: 'redeemed-credit-writing',
  RedeemedCreditWritingCredit: 'redeemed-credit-writing-credit',
  CreditExtension: 'credit-extension',
  MiscSale: 'misc-sale',
}

export const ORDER_TABS = {
  [OrderTypes.UnSelected]: [
    {
      id: uuid(),
      name: TabNames.Credits,
      tab: markRaw(CreditsTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.OrderType,
      tab: markRaw(OrderTypeTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
  ],
  [OrderTypes.Normal]: [
    {
      id: uuid(),
      name: TabNames.Credits,
      tab: markRaw(CreditsTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.OrderType,
      tab: markRaw(OrderTypeTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.Packages,
      tab: markRaw(PackagesTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.Upload,
      tab: markRaw(UploadTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Images,
      tab: markRaw(ImagesTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Targeting,
      tab: markRaw(TargetingTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Schedule,
      tab: markRaw(ScheduleTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
  ],
  [OrderTypes.CreditOnly]: [
    {
      id: uuid(),
      name: TabNames.Credits,
      tab: markRaw(CreditsTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.OrderType,
      tab: markRaw(OrderTypeTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.Prepay,
      tab: markRaw(PrepayTabContent),
      showAsidePanel: false,
      isWideContainer: true,
    },
  ],
  [OrderTypes.WritingService]: [
    {
      id: uuid(),
      name: TabNames.Credits,
      tab: markRaw(CreditsTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.OrderType,
      tab: markRaw(OrderTypeTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.Packages,
      tab: markRaw(PackagesTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.Writing,
      tab: markRaw(WritingTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Images,
      tab: markRaw(ImagesTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Targeting,
      tab: markRaw(TargetingTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
  ],
  [OrderTypes.RedeemedCredit]: [
    {
      id: uuid(),
      name: TabNames.OrderType,
      tab: markRaw(OrderTypeTabContent),
      showAsidePanel: false,
      isWideContainer: false,
      tabs: {
        normal: [
          {
            id: uuid(),
            name: TabNames.OrderType,
            tab: markRaw(OrderTypeTabContent),
            showAsidePanel: false,
            isWideContainer: false,
          },
          {
            id: uuid(),
            name: TabNames.Upload,
            tab: markRaw(UploadTabContent),
            showAsidePanel: true,
            isWideContainer: true,
          },
          {
            id: uuid(),
            name: TabNames.Images,
            tab: markRaw(ImagesTabContent),
            showAsidePanel: true,
            isWideContainer: true,
          },
          {
            id: uuid(),
            name: TabNames.Targeting,
            tab: markRaw(TargetingTabContent),
            showAsidePanel: true,
            isWideContainer: true,
          },
          {
            id: uuid(),
            name: TabNames.Schedule,
            tab: markRaw(ScheduleTabContent),
            showAsidePanel: true,
            isWideContainer: true,
          },
        ],
        'writing-service': [
          {
            id: uuid(),
            name: TabNames.OrderType,
            tab: markRaw(OrderTypeTabContent),
            showAsidePanel: false,
            isWideContainer: false,
          },
          {
            id: uuid(),
            name: TabNames.Writing,
            tab: markRaw(WritingTabContent),
            showAsidePanel: true,
            isWideContainer: true,
          },
          {
            id: uuid(),
            name: TabNames.Images,
            tab: markRaw(ImagesTabContent),
            showAsidePanel: true,
            isWideContainer: true,
          },
          {
            id: uuid(),
            name: TabNames.Targeting,
            tab: markRaw(TargetingTabContent),
            showAsidePanel: true,
            isWideContainer: true,
          },
        ],
      },
    },
  ],
  [OrderTypes.RedeemedCreditWritingCredit]: [
    {
      id: uuid(),
      name: TabNames.Writing,
      tab: markRaw(WritingTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Images,
      tab: markRaw(ImagesTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Targeting,
      tab: markRaw(TargetingTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
  ],
  [OrderTypes.RedeemedCreditWriting]: [
    {
      id: uuid(),
      name: TabNames.OrderType,
      tab: markRaw(OrderTypeTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
    {
      id: uuid(),
      name: TabNames.Writing,
      tab: markRaw(WritingTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Images,
      tab: markRaw(ImagesTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
    {
      id: uuid(),
      name: TabNames.Targeting,
      tab: markRaw(TargetingTabContent),
      showAsidePanel: true,
      isWideContainer: true,
    },
  ],
  [OrderTypes.CreditExtension]: [
    {
      id: uuid(),
      name: TabNames.Prepay,
      tab: markRaw(PrepayTabContent),
      showAsidePanel: false,
      isWideContainer: false,
    },
  ],
}
